enum MemberState {
  JOINED = "joined",
  SUBMITTED_RESTAURANT_CATEGORY_PREFERENCES = "submitted_restaurant_category_preferences",
  SUBMITTED_RESTAURANT_PREFERENCES = "submitted_restaurant_preferences",
}

export default MemberState;
